import { render, staticRenderFns } from "./forbidden-page.vue?vue&type=template&id=5d545697&scoped=true"
import script from "./forbidden-page.vue?vue&type=script&lang=js"
export * from "./forbidden-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d545697",
  null
  
)

export default component.exports